export default "__VITE_ASSET__oMf5gQUe__"